import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { ApsModalHeader, ApsModalBody, ApsButton, ApsButtonGroup } from 'UserExperience/portal-vnext';

const DeleteDocumentModal = ({ visible, onOk, onCancel }) => {

  const { t } = useTranslation();
  const modalTitle = t('uploadScreen.confirmDelete.title');
  const noButtonLabel = t('uploadScreen.confirmDelete.noButton');
  const yesButtonLabel = t('uploadScreen.confirmDelete.yesButton');

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      closable={false}
      footer = {null}
      centered={true}
      wrapClassName="modal-size-is-small"
      bodyStyle={{padding:0, fontSize: 16}}
      width={280}
      destroyOnClose={true}
    >
      {/* existing portal css needs some wrapper element so modal font, etc., will be applied */}
      <emulate-ng-include>
        <ApsModalHeader
          titleText={modalTitle}
          titleAlign="center"
          titleSize="small"
          closeButton={false}
        />
        <ApsModalBody hasPadding={true}>
          <ApsButtonGroup
            groupInset={true}
            groupType="separate"
          >
            <ApsButton
              buttonBlock={true}
              buttonLabel={yesButtonLabel}
              buttonShape="pill"
              buttonType="primary"
              onClick={onOk}
            />
            <ApsButton
              buttonBlock={true}
              buttonLabel={noButtonLabel}
              buttonShape="pill"
              buttonType="secondary-outline"
              onClick={onCancel}
            />
          </ApsButtonGroup>
        </ApsModalBody>
      </emulate-ng-include>
    </Modal>
  );
};

export default DeleteDocumentModal;